import { api } from "@shared/lib/api";
import { BackednResponse, IFilTerValue } from "@shared/lib/types";
import { Review } from "@shared/lib/types/agency";
import { IUserDownload } from "@shared/lib/types/downloads";

export class DownloadService {
  public static async fetchUserDownloads(): Promise<
    BackednResponse<IUserDownload[]>
  > {
    const url = `download`;
    const downloads = (await api.get(url).json()) as BackednResponse<
      IUserDownload[]
    >;
    return downloads;
  }

  public static async downloadInfluencers(
    platform: string,
    searchQuery: string,
    filters: { [key: string]: IFilTerValue },
    bucketId?: string
  ) {
    const url = `download/bucketInfluencers`;
    await api
      .post(url, {
        json: {
          platform,
          searchQuery,
          ...filters,
          bucket: bucketId,
        },
      })
      .json();
  }
  public static async downloadBriefInfluencers(
    briefId: string,
    status?: string
  ) {
    const url = `download/breifInfluencers`;
    await api
      .post(url, {
        json: {
          briefId,
          status,
        },
      })
      .json();
  }
  public static async downloadReports(reportId: string) {
    const url = `download/reportMedias`;
    await api
      .post(url, {
        json: {
          reportId,
        },
      })
      .json();
  }
}
